import { jsx as _jsx } from "react/jsx-runtime";
import { StrategyMapCanvas } from './StrategyMapCanvas';
/**
 * StrategyMapView - Wrapper component that renders the infinite spatial canvas
 * for the strategy map. This replaces the old static layout with the new
 * infinite canvas implementation that supports pan/zoom and advanced filtering.
 */
export function StrategyMapView() {
    return _jsx(StrategyMapCanvas, {});
}
